import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'
import ArgonDashboard from './plugins/argon-dashboard'
import  store from './Services/store'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import VueFlatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import axios from 'axios'


Vue.config.productionTip = false

var base = axios.create({
  baseURL: `http://222.255.100.41:3000`,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
    "Access-Control-Allow-Origin": "*",
  }
})
Vue.prototype.$http = base
const token = localStorage.getItem('token')
if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = 'jwt ' + token
}
Vue.use(ArgonDashboard)

Vue.use(VueMoment,{moment,})
Vue.use(VueFlatPickr)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
